/**
 * 合作金融机构公告页面配置文件
 */

/**
 * 页面Key标识
 * 用于接口请求的场景值
 */
const G_PAGE_KEY = 'S_COOPERATION_INSTITUTION'

/**
 * 页面描述
 */
const G_PAGE_DESC = '分期乐官网合作金融机构公告页面'

/**
 * 楼层配置
 */
const G_FLOOR_CONFIG = [
    { floorId: 'F_TOP', propKey: 'topFloor', desc: '页面头部' },
    { floorId: 'F_MID', propKey: 'midFloor', desc: '页面中间列表' },
    { floorId: 'F_BOTTOM', propKey: 'bottomFloor', desc: '页面底部' }
]

/**
 * 楼层ID到属性名的映射
 */
const G_FLOOR_MAP = G_FLOOR_CONFIG.reduce((map, config) => {
    map[config.floorId] = config.propKey
    return map
}, {})

/**
 * 楼层数据初始值
 */
const G_FLOOR_INFO_INIT = G_FLOOR_CONFIG.reduce((info, config) => {
    info[config.propKey] = {}
    return info
}, {})

/**
 * 运营位ID配置
 */
const G_POSITION_ID = {
    // 页面头部楼层
    top_floor: {
        backgroundImage: `${G_PAGE_KEY}.F_TOP.P_BACKGROUND_IMAGE`,  // 移动端头部背景图和logo
        pcTop: `${G_PAGE_KEY}.F_TOP.P_PC_TOP`  // PC端头部背景图、logo和标题图
    },
    // 页面中间列表楼层
    mid_floor: {
        list: `${G_PAGE_KEY}.F_MID.P_LIST`  // 金融机构列表
    },
    // 页面底部楼层
    bottom_floor: {
        text: `${G_PAGE_KEY}.F_BOTTOM.P_TEXT`  // 底部文字
    }
}

// 统一导出
export {
    G_PAGE_KEY,
    G_PAGE_DESC,
    G_FLOOR_CONFIG,
    G_FLOOR_MAP,
    G_FLOOR_INFO_INIT,
    G_POSITION_ID
}